import { render, staticRenderFns } from "./TriumphTile.vue?vue&type=template&id=ec40f594&scoped=true&"
import script from "./TriumphTile.vue?vue&type=script&lang=js&"
export * from "./TriumphTile.vue?vue&type=script&lang=js&"
import style0 from "./TriumphTile.vue?vue&type=style&index=0&id=ec40f594&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec40f594",
  null
  
)

export default component.exports